/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * @param affiliateAddress
 * @param affiliateReferralCode
 * @param affiliateEarnings
 * @param affiliateReferredTrades
 * @param affiliateTotalReferredFees
 * @param affiliateReferredUsers
 * @param affiliateReferredNetProtocolEarnings
 * @param affiliateReferredTotalVolume
 * @param affiliateReferredMakerFees
 * @param affiliateReferredTakerFees
 * @param affiliateReferredMakerRebates
 */
@JsExport
@Serializable
data class IndexerAffiliateSnapshotResponseObject(

    val affiliateAddress: kotlin.String? = null,
    val affiliateReferralCode: kotlin.String? = null,
    val affiliateEarnings: kotlin.Double? = null,
    val affiliateReferredTrades: kotlin.Double? = null,
    val affiliateTotalReferredFees: kotlin.Double? = null,
    val affiliateReferredUsers: kotlin.Double? = null,
    val affiliateReferredNetProtocolEarnings: kotlin.Double? = null,
    val affiliateReferredTotalVolume: kotlin.Double? = null,
    val affiliateReferredMakerFees: kotlin.Double? = null,
    val affiliateReferredTakerFees: kotlin.Double? = null,
    val affiliateReferredMakerRebates: kotlin.Double? = null
)
